var React = require('react');

function WebinarIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#3122A3","d":"M0 0h129v129H0z","key":0}),React.createElement("path",{"d":"M39 39h52v52H39z","key":1}),React.createElement("path",{"fill":"#FFF","d":"M48.455 67.922v9.905L65 87.286l16.545-9.46v-9.904L65 77.38l-16.545-9.46zM65 42.714L39 57.571 65 72.43l21.273-12.16v17.111H91v-19.81L65 42.714z","key":2})]));
}

WebinarIcon.displayName = "WebinarIcon";

WebinarIcon.defaultProps = {"width":"129","height":"129"};

module.exports = WebinarIcon;

WebinarIcon.default = WebinarIcon;
